module.exports = __webpack_public_path__ + "assets/heart.32c3c867cfc949497f11254dfd3b962a.png";